import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { PositiveImageryIntroAudio } from "@/lib/data/positive-imagery";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/stores/authStore";
import { usePositiveImageryStore } from "@/lib/stores/positiveImageryStore";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/positive-imagery/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "An Exercise Through Positive Imagery - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "positiveImagery.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { hasSessions, fetchSessions } = usePositiveImageryStore();

  useEffect(() => {
    if (user) {
      fetchSessions().catch(console.error);
    }
  }, [user, fetchSessions]);

  const showArchiveButton = user && hasSessions();

  const currentSegment = PositiveImageryIntroAudio[0];

  const startExercise = () => {
    navigate({ to: "/adults/exercises/positive-imagery/exercise" });
  };

  const handleArchive = () => {
    navigate({ to: "/adults/exercises/positive-imagery/archive" });
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <>
          <Button className="w-full" onClick={startExercise}>
            <FormattedMessage id="positiveImagery.intro.start.button" />
          </Button>
          {showArchiveButton && (
            <Button
              className="w-full"
              variant="secondary"
              onClick={handleArchive}
            >
              <FormattedMessage id="conversingTogether.archive.button" />
            </Button>
          )}
        </>
      }
    >
      <p className="text-small">
        <FormattedMessage id="positiveImagery.intro.description" />
      </p>
      <MediaPlayer
        src={currentSegment.audio}
        segment={currentSegment.segment}
      />
    </ExerciseLayout>
  );
}
